import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export const formatDateTime = (iso?: string): string => {
	if (!iso) return "\u2014";
	const date = new Date(iso);
	if (!Number.isFinite(date.getTime())) return "\u2014";
	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	});
};

export const getAudienceSummary = (
	item: ContentTableItem,
	groupNamesById?: Map<number, string>
): string => {
	const type = item.data?.audienceType as string;
	const platform = item.data?.audiencePlatform as string | null;
	const userIds = item.data?.audienceUserIds as string[] | undefined;
	const groupIds = item.data?.audienceGroupIds as number[] | undefined;
	if (type === "everyone") return "Everyone";
	if (type === "platform") {
		if (platform === "ios") return "iOS only";
		if (platform === "android") return "Android only";
		return "Both platforms";
	}
	if (type === "users") {
		const count = userIds?.length ?? 0;
		return `${count} user${count !== 1 ? "s" : ""}`;
	}
	if (type === "groups") {
		const ids = groupIds ?? [];
		// Single group: show its name when we can resolve it (the admin
		// list passes a name lookup via useAdminGroups). Multi-group, or
		// missing lookup, falls back to a count so the column always
		// reads something meaningful.
		if (ids.length === 1 && groupNamesById) {
			const name = groupNamesById.get(ids[0]);
			if (name) return name;
		}
		return `${ids.length} group${ids.length !== 1 ? "s" : ""}`;
	}
	return "\u2014";
};

export const getRelevantDate = (item: ContentTableItem): string => {
	const status = item.data?.status as string;
	if (status === "sent") return formatDateTime(item.data?.sentAt as string);
	if (status === "scheduled")
		return formatDateTime(item.data?.scheduledAt as string);
	if (status === "expired")
		return formatDateTime(item.data?.expiresAt as string);
	return formatDateTime(item.lastUpdated);
};

export const isDraftAnnouncement = (item: ContentTableItem): boolean => {
	return (item.data?.status as string) === "draft";
};

export const getDateLabel = (item: ContentTableItem): string => {
	const status = item.data?.status as string;
	if (status === "sent") return "Sent";
	if (status === "scheduled") return "Scheduled for";
	if (status === "expired") return "Expired";
	return "Last updated";
};
